import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle, Instagram } from 'lucide-react';
import { Logo } from './Logo';
export function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-[#050505] pt-20 pb-10 border-t border-brand-gold/20" data-id="element-207">
      <div className="max-w-7xl mx-auto px-6" data-id="element-208">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16" data-id="element-209">
          {/* Brand Col */}
          <div className="lg:col-span-2" data-id="element-210">
            <Logo className="mb-6" data-id="element-211" />
            <p className="text-brand-gold font-bold tracking-widest text-sm mb-6" data-id="element-212">
              RÁPIDO, SIMPLE, CONFIABLE.
            </p>
            <p className="text-brand-white/60 text-sm max-w-sm" data-id="element-213">
              Tu socio estratégico en el mercado automotor argentino. Compra,
              venta, alquiler e inversiones.
            </p>
          </div>

          {/* Links Col 1 */}
          <div data-id="element-214">
            <h4 className="text-brand-white font-bold mb-6" data-id="element-215">Servicios</h4>
            <ul className="space-y-4" data-id="element-216">
              <li data-id="element-217">
                <button onClick={() => scrollToSection('compra-venta')} className="text-brand-white/60 hover:text-brand-gold transition-colors text-sm" data-id="element-218">
                  Compra y Venta
                </button>
              </li>
              <li data-id="element-219">
                <button onClick={() => scrollToSection('alquiler')} className="text-brand-white/60 hover:text-brand-gold transition-colors text-sm" data-id="element-220">
                  Alquiler para Apps
                </button>
              </li>
              <li data-id="element-221">
                <button onClick={() => scrollToSection('consignacion')} className="text-brand-white/60 hover:text-brand-gold transition-colors text-sm" data-id="element-222">
                  Consignación
                </button>
              </li>
              <li data-id="element-223">
                <a href="https://project-flash-and-go-investor-landing-page-109.magicpatterns.app" className="text-brand-white/60 hover:text-brand-gold transition-colors text-sm" data-id="element-224">
                  Inversiones
                </a>
              </li>
            </ul>
          </div>

          {/* Links Col 2 */}
          <div data-id="element-225">
            <h4 className="text-brand-white font-bold mb-6" data-id="element-226">Empresa</h4>
            <ul className="space-y-4" data-id="element-227">
              <li data-id="element-228">
                <button onClick={() => window.scrollTo(0, 0)} className="text-brand-white/60 hover:text-brand-gold transition-colors text-sm" data-id="element-229">
                  Inicio
                </button>
              </li>
              <li data-id="element-230">
                <button onClick={() => scrollToSection('contacto')} className="text-brand-white/60 hover:text-brand-gold transition-colors text-sm" data-id="element-231">
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Col */}
          <div data-id="element-232">
            <h4 className="text-brand-white font-bold mb-6" data-id="element-233">Contacto</h4>
            <ul className="space-y-4 text-sm text-brand-white/60" data-id="element-234">
              <li data-id="element-235">Los Patos 2927, Parque Patricios CABA</li>
              <li data-id="element-236">Lunes a sábados 9 a 19hs</li>
              <li data-id="element-237">+54 9 11 6889-8054</li>
            </ul>
            <div className="flex gap-4 mt-6" data-id="element-238">
              <a href="https://wa.me/5491168898054" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[#111] border border-brand-gold/30 flex items-center justify-center text-brand-gold hover:bg-brand-gold hover:text-brand-black transition-colors" data-id="element-239">
                <MessageCircle className="w-5 h-5" data-id="element-240" />
              </a>
              <a href="https://instagram.com/flash.go.arg" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[#111] border border-brand-gold/30 flex items-center justify-center text-brand-gold hover:bg-brand-gold hover:text-brand-black transition-colors" data-id="element-241">
                <Instagram className="w-5 h-5" data-id="element-242" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-brand-gold/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-243">
          <p className="text-brand-white/40 text-sm" data-id="element-244">
            © 2026 Flash & Go — Todos los derechos reservados
          </p>
        </div>
      </div>
    </footer>;
}